module.exports = __webpack_public_path__ + "img/hero-slide-2.cd8872d1.png";